import FeatureContextMenu from './components/FeatureContextMenu';

/**
 * ReactDOM é um pacote que fornece métodos específicos do DOM que podem
 * ser usados no nível superior do seu aplicativo e como uma saída de 
 * emergencia para sair do modelo React.
 */
import ReactDOM from 'react-dom';

/**
 * Função que dispara um menu ao clicar em cima de uma
 * feature leaflet com botão direito do mouse, para isso
 * é criado um novo componente na DOM que é desfeito assim
 * que concluído seu trabalho
 *
 * @param {object} selectedLayer A camada leaflet que estamos interagindo com
 * @param {object} anchorPosition Coordenadas do clique do mouse { mouseX, mouseY }
 * @param {array} features A lista de features que estamos interagindo, importante para poder retornar a nova lista de features para atualização de state ao excluir uma feature, já que o state do leaflet é diferente
 * @param {object} map Leaflet map
 * @param {function} listener Função de callback com alguns escutadores como ctxmenu:featureremoved
 * @param {object} measurementsOptions Opções para a exibição das medidas, ao ocultar e reexibir
 * @param {array} options Opções de escolha
 */
/**
 * ReactDOM.render() função recebe dois argumentos, codigo HTML e um 
 * elemento html, a função tem como objetivo exibir o codigo HTML espe-
 * cificado dentro do elemento HTML especificado.
 */
export default ({
  selectedLayer,
  anchorPosition,
  features,
  map,
  listener,
  measurementsOptions,
  options,
}) => {
  ReactDOM.render(
    <FeatureContextMenu
      selectedLayer={selectedLayer}
      anchorPosition={anchorPosition}
      listener={listener}
      features={features}
      map={map}
      measurementsOptions={measurementsOptions}
      options={options}
    />,
    document.getElementById('apendix')
  );
};
